:host {
  --grid-template-areas: var(
    --stzh-contact-grid-template-areas,
    "heading heading heading heading" "image image image image"
      "responsibility responsibility responsibility responsibility"
      "contactForm contactForm contactForm contactForm" "info info info info"
      "availability availability availability availability"
      "additional additional additional additional"
  );

  --grid-template-columns: var(
    --stzh-contact-grid-template-columns,
    #{$gridColumns}
  );

  @include mq($from: medium) {
    --grid-template-areas: var(
      --stzh-contact-grid-template-areas,
      "heading heading heading heading heading heading heading heading"
        "image image image image . . . ."
        "responsibility responsibility responsibility responsibility responsibility responsibility . ."
        "contactForm contactForm contactForm contactForm contactForm contactForm contactForm contactForm"
        "info info info info availability availability availability availability"
        "additional additional additional additional additional additional additional additional"
    );

    --grid-template-columns: var(
      --stzh-contact-grid-template-columns,
      #{$gridColumnsMedium}
    );
  }

  @media print {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  ::slotted([slot="image"]) {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &[has-availability="false"] {
    @include mq($from: medium) {
      --grid-template-areas: var(
        --stzh-contact-grid-template-areas,
        "heading heading heading heading heading heading heading heading"
          "image image image image . . . ."
          "responsibility responsibility responsibility responsibility responsibility responsibility . ."
          "contactForm contactForm contactForm contactForm contactForm contactForm contactForm contactForm"
          "info info info info info info info info"
          "additional additional additional additional additional additional additional additional"
      );
    }
  }
}

.stzh-contact {
  @include fontCurve("p1");
  @include gridGutter;
  display: grid;
  grid-template-areas: var(--grid-template-areas);
  grid-template-columns: var(--grid-template-columns);

  &__main-heading {
    grid-area: heading;

    ::slotted([slot="main-heading"]) {
      display: none;
    }

    &:not(:empty) {
      margin-bottom: space("xlarge");

      @include mq($from: large) {
        margin-bottom: space("xxlarge");
      }
    }
  }

  &__main-heading-type {
    &:not(:empty) {
      padding-top: space("xsmall");
      padding-bottom: space("xxsmall");

      @include mq($from: small) {
        padding-top: space("small");
        padding-bottom: space("xxsmall");
      }

      @include mq($from: medium) {
        padding-top: space("xsmall");
        padding-bottom: space("xsmall");
      }

      @include mq($from: large) {
        padding-top: space("small");
        padding-bottom: space("small");
      }
    }
  }

  &__main-heading-section {
    &:not(:empty) {
      margin-bottom: space("medium");
      padding-top: space("medium");
      padding-bottom: space("xxsmall");

      @include mq($from: small) {
        margin-bottom: space("large");
        padding-top: space("large");
        padding-bottom: space("xxsmall");
      }

      @include mq($from: medium) {
        margin-bottom: space("xlarge");
        padding-top: space("xlarge");
        padding-bottom: space("xsmall");
      }

      @include mq($from: large) {
        margin-bottom: space("xxlarge");
        padding-top: space("xxlarge");
        padding-bottom: space("small");
      }
    }
  }

  &__main-heading-text {
    &:not(:empty) {
      margin-bottom: space("xsmall");
    }
  }

  &__image-wrapper {
    grid-area: image;
    background-color: $colorSecondary20;
  }

  &__role,
  &__departament {
    @include fontSize("milli");
    @include font("medium");
  }

  &__image {
    position: relative;
  }

  &__info {
    grid-area: info;
  }

  &__responsibility {
    grid-area: responsibility;

    &:not(:empty) {
      margin-bottom: space("xlarge");

      @include mq($from: large) {
        margin-bottom: space("xxlarge");
      }
    }
  }

  &__responsibility-text {
    &:not(:empty) {
      padding-bottom: space("xsmall");

      @include mq($from: small) {
        padding-bottom: space("small");
      }

      @include mq($from: medium) {
        padding-bottom: space("medium");
      }

      @include mq($from: large) {
        padding-bottom: space("small");
      }
    }
  }

  &__contact-form {
    grid-area: contactForm;

    @include spaceCurve("gap", "regular");
    display: grid;

    ::slotted(*) {
      margin-bottom: space("xlarge");

      @include mq($from: large) {
        margin-bottom: space("xxlarge");
      }
    }
  }

  &__additional {
    grid-area: additional;

    @include spaceCurve("gap", "regular");
    display: grid;

    ::slotted(*) {
      margin-top: space("xlarge");
      margin-bottom: space("xlarge");

      @include mq($from: large) {
        margin-top: space("xxlarge");
        margin-bottom: space("xxlarge");
      }
    }
  }

  &__heading,
  &__name,
  &__pobox,
  &__availability-title,
  &__websites {
    &:not(:empty):not(:last-child) {
      margin-bottom: space("xsmall");
    }
  }

  &__numbers {
    white-space: nowrap;
  }

  &__number,
  &__email,
  &__website {
    display: flex;
    align-items: center;
    gap: space("xxsmall");
  }

  &__website {
    display: flex;
    flex-direction: row;
    --stzh-datalist-item-vertical-wrapper-padding: 0px;
  }

  &__heading,
  &__name,
  &__role,
  &__departament,
  &__availability-title {
    @include fontCurve("p1");
    margin: 0px;
  }

  &__heading,
  &__name.is-heading,
  &__availability-title {
    @include font("heavy");
  }

  &__availability {
    grid-area: availability;
    margin-top: space("xlarge");
    @include spaceCurve("gap", "small");

    @include mq($from: medium) {
      margin-top: 0px;
    }
  }

  &__availability-list,
  &__availability-hour-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__availability-list {
    @include spaceCurve("gap", "small");
    display: grid;
  }

  &__availability-weekday {
    @include fontCurve("p1");
  }

  &__availability-hours {
    display: flex;
    flex-direction: column;

    @include mq($from: small) {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      column-gap: space("xsmall");
    }
  }

  &__availability-hours-separator {
    width: 1px;
    background-color: currentColor;
    flex-shrink: 0;
  }

  &--has-image &__image {
    width: 64px;
    height: 64px;

    @include mq($from: small) {
      width: 80px;
      height: 80px;
    }

    @include mq($from: medium) {
      width: 100px;
      height: 100px;
    }

    @include mq($from: large) {
      width: 120px;
      height: 120px;
    }

    @include mq($from: ultra) {
      width: 140px;
      height: 140px;
    }
  }

  &__image-wrapper {
    background-color: transparent;
  }
}
